export const SET_LOADING = "SET_LOADING";
export const SET_HOME_DATA = "SET_HOME_DATA";
export const SET_ABOUT_DATA = "SET_ABOUT_DATA";
export const SET_PRIVACY_DATA = "SET_PRIVACY_DATA";
export const SET_TERMS_DATA = "SET_TERMS_DATA";
export const SET_SETTING_DATA = "SET_SETTING_DATA";
export const SET_FAQ_DATA = "SET_FAQ_DATA";
export const SET_COURSE_DATA = "SET_COURSE_DATA";
export const SET_PAGE="SET_PAGE";
export const RAZOR_PAY="RAZOR_PAY";